module.exports = __webpack_public_path__ + "static/bank-SPD.16a70e8d.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/financing/bank-SPD.png
// module id = 975
// module chunks = 2